import React from 'react';
import classnames from 'classnames';

interface IRowProps {
  label: string;
  children: React.ReactNode;
}

function Row({ label, children }: IRowProps) {
  return (
    <>
      <dt>
        {label}
      </dt>
      <dd>
        {children}
      </dd>
    </>
  );
}

interface IProps {
  /* Should be one or more SellFormKeyValueList.Row components */
  children: React.ReactNode;
  fullHeightContainer?: boolean;
}

export function SellFormKeyValueList({ children, fullHeightContainer }: IProps) {
  const classes = classnames('sell-form-key-value-list', { 'sell-form-key-value-list--margin-top': !fullHeightContainer });

  return (
    <dl className={classes}>
      {children}
    </dl>
  );
}

SellFormKeyValueList.Row = Row;
